// List of known crawler/bot user-agent signatures.
// Any of these should NEVER be geo-redirected — they need to see
// the actual page content on whatever domain they requested,
// otherwise indexing breaks (this is what caused the blog fetch
// to abort mid-render for Googlebot).
const BOT_UA_PATTERNS = [
  'googlebot',
  'bingbot',
  'slurp',          // Yahoo
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'sogou',
  'exabot',
  'facebot',        // Facebook link preview
  'facebookexternalhit',
  'twitterbot',
  'linkedinbot',
  'slackbot',
  'discordbot',
  'whatsapp',
  'telegrambot',
  'applebot',
  'petalbot',
  'ahrefsbot',
  'semrushbot',
  'mj12bot',
  'gptbot',         // OpenAI
  'chatgpt-user',
  'ccbot',          // Common Crawl
  'claudebot',
  'anthropic-ai',
  'perplexitybot',
];

function isKnownBot() {
  const ua = (navigator.userAgent || '').toLowerCase();
  return BOT_UA_PATTERNS.some((pattern) => ua.includes(pattern));
}

// Only run geo-redirect on entry points where a wrong-region visitor
// landing is actually costly (e.g. the homepage). Never run it on
// content routes like /blogs/* — an interrupted navigation there
// aborts in-flight data fetches (e.g. getBlogBySlug) and produces
// a false "not found" error state.
function isEligibleRoute() {
  const path = window.location.pathname;
  return path === '/' || path === '';
}

export async function handleGeoRedirect() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return;

  // Never redirect crawlers/bots — they must see the content on the
  // domain they requested, or indexing breaks.
  if (isKnownBot()) return;

  // Only redirect from routes where it's safe to interrupt navigation.
  if (!isEligibleRoute()) return;

  const isOnDotCom = hostname.includes('algdataguard.com');
  const isOnDotCa  = hostname.includes('algdataguard.ca');

  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    const isCanadian = data.country_code === 'CA';

    if (isCanadian && isOnDotCom) {
      window.location.replace(`https://algdataguard.ca${window.location.pathname}`);
    }
    if (!isCanadian && isOnDotCa) {
      window.location.replace(`https://algdataguard.com${window.location.pathname}`);
    }
  } catch (e) {
    console.error('Geo redirect failed:', e);
  }
}